import script from "./rateFormater.vue?vue&type=script&setup=true&lang=js"
export * from "./rateFormater.vue?vue&type=script&setup=true&lang=js"

import "./rateFormater.vue?vue&type=style&index=0&id=44dd072e&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44dd072e"]])

export default __exports__